import COLORS from '../../../../../utils/constants/colors'

const connectedGameDialogStyles = {
  subheader: {
    fontSize: '0.8rem',
    fontWeight: 600,
    color: COLORS.grey,
    lineHeight: '2.2',
    backgroundColor: COLORS.white,
  },
  listItemText: {
    fontSize: '0.9rem',
    fontWeight: 500,
  },
  emptyText: {
    fontSize: '0.9rem',
    fontWeight: 500,
    padding: '0 16px',
  },
}

export default connectedGameDialogStyles
